<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp; Monthly Conveyance Reports</h5>
  </div>
<div id="mainContent" class="container">
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Financial Year<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedFinancialYear"
              (change)="onFinancialYearSelected()"
            >
              <option value="">Select Year</option>
              <option *ngFor="let finance of financialList" [ngValue]="finance">
                {{ finance.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Closing Date<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedClosing"
            >
              <option value="">Select Date</option>
              <option
                *ngFor="let closing of closingDateList"
                [ngValue]="closing"
              >
                {{ closing.closingDate }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Employee Status<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedEmployee"
            >
              <option value="1">Active</option>
              <option value="0">Closed</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Roles<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <mat-form-field appearance="legacy" style="width: 100%">
              <mat-select
                multiple
                [(ngModel)]="selectedRole"
                #designateRole="ngModel"
              >
                <mat-option
                  (click)="selectAllRole(designateRole, roleList)"
                  [value]="0"
                  >Select All
                </mat-option>
                <mat-option #item *ngFor="let role of roleList" [value]="role">
                  {{ role.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Branch<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <mat-form-field appearance="legacy" style="width: 100%">
              <mat-select
                multiple
                [(ngModel)]="selectedBranch"
                #designateBranch="ngModel"
              >
                <mat-option
                  (click)="selectAllBranch(designateBranch, branchList)"
                  [value]="0"
                  >Select All
                </mat-option>
                <mat-option
                  #item
                  *ngFor="let branch of branchList"
                  [value]="branch"
                >
                  {{ branch.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="col-sm-5">
        <div class="row">
          <!-- <div class="col-sm-6"></div> -->
          <div class="col-sm-4">
            <button
              class="btn btn-sm btn-block btn-outline-theme"
              (click)="onViewReport()"
            >
              View Details
            </button>
          </div>
        </div>
      </div>
    </div>
</div>
</div>
    
    <div
      class="container pt-3 pb-2"  id="mainContent" 
      *ngIf="monthlyConveyanceList != null"
    >

    <div class="row justify-content-center text-center">
      <span class="bg-theme-title"
        >P G BHAGWAT LLP, Chartered Accountants
      </span>
    </div>
    <div class="row justify-content-center text-center ">
      <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
    </div>

      <div class="row justify-content-center text-center mt-2">
          <span class="bg-theme-title"
            >Financial Year {{ selectedFinancialYear.name }}</span
          >
      </div>
      <div *ngFor="let role of monthlyConveyanceList.roles">
        <div class="row mt-2">
          <div class="col-sm-6">
            <label class="col-form-label"
              ><b>Role: {{ role.role }}</b></label
            >
          </div>
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-5"></div>
              <div class="col-sm-6">
                <label class="col-form-label">
                  <b
                    >Closing Date: {{selectedClosing.closingDate==='Not Closed'?'Not Closed':selectedClosing.closingDate | date:'dd-MMM-yyyy'}}</b
                  ></label
                >
              </div>
            </div>
          </div>
        </div>
        <table class="table table-bordered table-sm table-striped">
          <thead>
            <tr>
              <th rowspan="2">Branch</th>
              <th rowspan="2">Employee Name</th>
              <th colspan="3" style="text-align: center">Conveyance</th>
            </tr>
            <tr>
              <th>Chargeble</th>
              <th>Non Chargeble</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <ng-container
              *ngFor="
                let branch of role.branches;
                let branchIndex = index;
                let branchCount = count
              "
            >
              <ng-container
                *ngFor="
                  let details of branch.details;
                  let detailIndex = index;
                  let detailsCount = count
                "
              >
                <tr *ngIf="detailIndex == 0">
                  <td [attr.rowspan]="detailsCount">{{ branch.branch }}</td>
                  <td>{{ details.firstName }} {{ details.lastName }}</td>
                  <td>{{ details.chargeble }}</td>
                  <td>{{ details.nonChargeble }}</td>
                  <td>{{ details.chargeble + details.nonChargeble }}</td>
                </tr>
                <tr *ngIf="detailIndex != 0">
                  <td>{{ details.firstName }} {{ details.lastName }}</td>
                  <td>{{ details.chargeble }}</td>
                  <td>{{ details.nonChargeble }}</td>
                  <td>{{ details.chargeble + details.nonChargeble }}</td>
                </tr>
                <tr
                  *ngIf="
                    branchCount == branchIndex + 1 &&
                    detailsCount == detailIndex + 1
                  "
                  style="background-color: #e1f4f7"
                >
                  <td>Total</td>
                  <td></td>
                  <td>{{ getChargableTotal(role.branches) }}</td>
                  <td>{{ getNonChargableTotal(role.branches) }}</td>
                  <td>
                    {{ getAllChargableNonChargableTotal(role.branches) }}
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
